import { CopyIcon, EditIcon, TrashIcon } from "assets";
import { useState } from "react";
import { copyToClipboard } from "utils/helpers/CopyToClipboard";

interface Props{
    clickedEdit:React.MouseEventHandler<HTMLLIElement> | undefined;
    clickedDelete:React.MouseEventHandler<HTMLLIElement> | undefined;
    copyId: string
}
const MenuDropdown:React.FC<Props>=({clickedDelete,clickedEdit, copyId})=>{
  const [copied, setCopied] = useState(false);
      const [showTooltip, setShowTooltip] = useState(true);
      const handleCopy = async (e: React.MouseEvent<HTMLLIElement>) => {
        e.stopPropagation();
        const success = await copyToClipboard(
          copyId ?? ""
        );
        if (success) {
          setCopied(true);
          setShowTooltip(false);
          setTimeout(() => {
            setCopied(false);
            setShowTooltip(true);
          }, 1500);
        }
      };
    return(
        <>
        <ul className="p-2">
              <li
                className="cursor-pointer rounded-sm hover:bg-primary-500 hover:text-white hover:shadow-md p-1 flex items-center"
                onClick={clickedEdit}
              >
              <EditIcon className="size-4 mr-2"/>  Edit
              </li>
              <li
                className="relative cursor-pointer rounded-sm hover:bg-primary-500 hover:text-white hover:shadow-md p-1 flex items-center"
                onClick={handleCopy}
              >
               <CopyIcon className="size-4 mr-2"/> Copy Id
                {copied && (
                <div className="absolute top-0 left-24 bg-green-500 text-white px-3 py-1 rounded shadow-md text-xs animate-fadeInOut z-30 ">
                  ID Copied!
                </div>
              )}
              </li>
              <li
                className="cursor-pointer rounded-sm hover:bg-primary-500 hover:text-white hover:shadow-md text-red-500 p-1 flex items-center"
                onClick={clickedDelete}
              >
               <TrashIcon className="size-4 mr-2"/> Delete
              </li>
            </ul>
        </>
    )
}
export default MenuDropdown;